module.exports = __webpack_public_path__ + "img/left-leg_hover.2f0997c8.png";